import { AfterViewInit, Component, OnDestroy, OnInit, inject } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable, Subject, takeUntil } from 'rxjs';
import { SpinnerState } from 'src/app/shared/ui/spinner/redux/spinner.state';
import { SmartCleanService } from '../../services/smart-clean.service';
import { CleanScoreState, LoadSmartCleanRecords, RemoveCleanScore } from '../redux';
import { SharedModule } from 'src/app/shared/shared.module';

@Component({
  selector: 'app-view-clean-score',
  templateUrl: './view-clean-score.component.html',
  styleUrls: ['./view-clean-score.component.scss'],
  standalone: true,
  imports: [SharedModule]
})
export class ViewCleanScoreComponent implements OnInit, AfterViewInit, OnDestroy {
  public smartCleanRecord$: Observable<any> = inject(Store).select(CleanScoreState.smartCleanRecords);
  public loading$: Observable<boolean> = inject(Store).select(SpinnerState.isLoading);
  private unsubscribe: Subject<void> = new Subject();

  public Object = Object;
  public spin;
  public cleanScoreRecords = [];
  public selectedPmaps = [];
  public selectedRobots: string[] = [];
  public loadedRobots: string[] = [];

  constructor(private store: Store, private service: SmartCleanService) {
    this.store.dispatch(LoadSmartCleanRecords);
  }

  public ngAfterViewInit(): void {
    this.robotIdClear();
  }

  public ngOnInit(): void {
    this.smartCleanRecord$.pipe(takeUntil(this.unsubscribe)).subscribe((data) => {
      if (data && data.length > 0) {
        this.service.populateFields(data, this.cleanScoreRecords);
        this.loadedRobots = this.selectedRobots;
      }
    });
    this.loading$.pipe(takeUntil(this.unsubscribe)).subscribe((data) => (this.spin = data));
  }

  public ngOnDestroy(): void {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  public robotIdAdd(event) {
    this.store.dispatch(new LoadSmartCleanRecords(event.label));
  }

  public robotIdRemove(event) {
    delete this.cleanScoreRecords[event.label];
    delete this.selectedPmaps[event.label];
    this.loadedRobots = this.selectedRobots;
  }

  public robotIdClear() {
    this.store.dispatch(new RemoveCleanScore());
    this.cleanScoreRecords = [];
    this.selectedPmaps = [];
    this.loadedRobots = [];
    this.selectedRobots = [];
  }
}
